<template>
  <b-dropdown right :text="summaryText" variant="outline-dark" @hide="saveChanges" ref="dropdown" :disabled="disabled" toggle-class="text-decoration-none">
    <b-dropdown-form style="min-width:320px" v-on:submit.prevent.stop="saveAndClose">
      <b-form-group label="Event Is:">
        <b-form-radio-group stacked v-model="status">
          <b-form-radio value="open">Open</b-form-radio>
          <b-form-radio value="closed">Closed</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-alert :show="!isValid" variant="danger">{{errorMessage}}</b-alert>
      <p class="text-right mb-0">
        <b-button size="sm" variant="secondary" @click="resetAndClose">Cancel</b-button>
        <b-button size="sm" variant="primary" @click="saveAndClose">Update</b-button>
      </p>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>

export default {
  name: 'EventStatusFilter',
  props: ['filter', 'disabled'],
  data () {
    return {
      status: this.filter.status,
      isValid: true,
      errorMessage: ''
    }
  },
  components: {},
  computed: {
    summaryText () {
      if (this.filter.status === 'closed') {
        return 'Closed'
      } else {
        return 'Open'
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    validate () {
      this.isValid = true
      if (this.status == null) {
        this.isValid = false
        this.errorMessage = 'Please select an option'
      }
      return this.isValid
    },
    resetAndClose (evt) {
      this.status = this.filter.status
      this.isValid = true
      this.errorMessage = ''
      this.$refs.dropdown.hide()
    },
    saveChanges (evt) {
      if (this.validate()) {
        this.commit()
      } else {
        evt.preventDefault()
      }
    },
    saveAndClose () {
      if (this.validate()) {
        this.$refs.dropdown.hide()
      }
    },
    commit () {
      this.filter.status = this.status
      this.$emit('input', this.filter)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/EventStatusFilter.vue